import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { cloudfrontPath } from '@utils/image'

export const GuestsVoicesContentItemImage = (): JSX.Element => (
  <div className="flex justify-center items-center w-[29.9vw] lg:w-[8.8vw] h-[29.9vw] lg:h-[8.8vw] bg-white rounded-[20px] shadow-toppage">
    <div className="w-[15.5vw] lg:w-[4.5vw]">
      <ImageWraper
        src={`${cloudfrontPath}/programs/icons/top/participants_voice.svg`}
        width={58}
        height={53}
      />
    </div>
  </div>
)
